<ng-container class="parent" *ngIf="formInfo$ | async as fi">
  <fin-form
    [schema]="fi.schema"
    [options]="fi.options"
    [data]="fi.data"
    [layout]="fi.layout"
    [layoutTemplates]="fi.layoutTemplates"
    (dataChange)="onDataChange($event)"
    [customStyleForDefinedTermsTooltip]="customStyleForDefinedTermsTooltip"
    (statusChanges)="onStatusChange($event)"
    [components]="addedComponents"
    class="inner-fields"
  >
  </fin-form>
</ng-container>
